import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PagenotfoundComponent } from "./pagenotfound/pagenotfound.component";
import { SigninComponent } from "./components/signin/signin.component";
const routes: Routes = [
  // { path: "", redirectTo: "/", pathMatch: "full" },
  {
    path: "",
    loadChildren: () =>
      import("./layouts/layouts.module").then(m => m.LayoutsModule)
  },
  { path: "signin", component: SigninComponent, data: { animation: "isLeft" } },

  {
    path: "login",
    loadChildren: () => import("./login/login.module").then(m => m.LoginModule),
    data: { animation: "isRight" }
  },

  {
    path: "**",
    component: PagenotfoundComponent,
    data: { animation: "isLeft" }
  }
];
// { onSameUrlNavigation: "reload" }
@NgModule({
  imports: [
    RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
